import React from 'react/addons';
import cx from 'classnames';


function noop() {}

var OptionWrapper = React.createClass({
  propTypes: {
    selected: React.PropTypes.bool.isRequired,

    onHover: React.PropTypes.func,
    onClick: React.PropTypes.func
  },

  getDefaultProps() {
    return {
      onHover: noop,
      onClick: noop
    };
  },

  render() {
    var {children, onHover, onClick} = this.props;

    var classes = {
      "ofs-SimpleChoice__Option": true,
      "ofs-SimpleChoice__Option--is-selected": this.props.selected,
    };

    return (
      <li className={cx(classes)}
        onMouseEnter={onHover.bind(null, children)}
        onMouseDown={onClick.bind(null, children)}>
        {children}
      </li>
    );
  }
});

export default OptionWrapper;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/simple-choice/OptionWrapper.jsx
 **/